import React from 'react'
import { MDXTag } from '@mdx-js/tag'


import DefaultLayout from "/var/lib/jenkins/jobs/app-styleguide/workspace/src/templates/guidelines.js"
import { Link } from 'gatsby'

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = DefaultLayout
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             Layout={this.layout} layoutProps={Object.assign({}, layoutProps, props)}
             components={components}>


<MDXTag name="h3" components={components} props={{"id":"All-forms-take-bottom-left-buttons-all-dialogues-are-right-and-all-overlays-middle"}}><MDXTag name="a" components={components} parentName="h3" props={{"href":"#All-forms-take-bottom-left-buttons-all-dialogues-are-right-and-all-overlays-middle","aria-label":"All forms take bottom left buttons all dialogues are right and all overlays middle permalink","class":"anchor"}}></MDXTag>{`All forms take bottom left buttons, all dialogues are right, and all overlays middle.`}</MDXTag>
<MDXTag name="p" components={components}>{`This is because making all `}<Link to="/elements/button">{`buttons`}</Link>{` on Tes ranged on one or other side all the time (in the name of consistency) will be too restrictive in some cases.`}</MDXTag>
<MDXTag name="p" components={components}>{`Note that on mobile: we `}<MDXTag name="em" components={components} parentName="p">{`prefer`}</MDXTag>{` all action buttons to be one the right (and their secondary/cancel items to their left)`}</MDXTag>
           </MDXTag>
  }
}

export const _frontmatter = {};

  